import { Box, Link as ChakraLink, LightMode, Stack } from "@chakra-ui/react"

import { Container } from "../../-components/Container"
import { FAQSection } from "../../-components/FAQs/Section"
import { Headline } from "../../-components/Headline"
import Link from "next/link"

export const PricingFAQs = () => {
    return (
        <Container py={24}>
            <LightMode>
                <Stack spacing={10}>
                    <Headline heading="Frequently Asked Questions" size="md" align="start" mb={6} />
                    <FAQSection data={data} />
                </Stack>
            </LightMode>
        </Container>
    )
}

const data = [
    {
        title: 'Is Rarchy a subscription service?',
        answer: (
            <Box>
                Yes, Rarchy is a recurring monthly or yearly subscription service that you can cancel at any time within the app, no questions asked.
            </Box>
        ),
    },
    {
        title: 'Can I try before I buy?',
        answer: (
            <Stack spacing={4}>
                <Box>
                    Yes, anyone can <ChakraLink as={Link} href="/app/signup">create a free account with Rarchy</ChakraLink>. Rarchy Free is designed for one user, with restricted features, and a limited number of projects.
                </Box>
                <Box>
                    This account is free forever, no credit card required.</Box>
                <Box>
                    When you are ready to upgrade to Rarchy Team or Rarchy Agency, use the button in the top left of the home page.
                </Box>
            </Stack>
        ),
    },
    {
        title: 'Can I change my plan later?',
        answer: "Yes, you can upgrade or downgrade your plan at any time, in-app. If you upgrade, the change happens immediately, and you'll only pay a prorated amount for the rest of the billing cycle. If you choose to downgrade, it'll take effect at the end of that billing cycle."
    },
    {
        title: 'Can you charge me in my local currency?',
        answer: (
            <Stack spacing={4}>
                <Box>
                    Yes, we currently accept payment in multiple currencies with more currencies being added on request.
                </Box>
                <Box>
                    Our currently accepted currencie are: USD, EUR, GBP, AUD, NZD
                </Box>
            </Stack>
        )
    },
    {
        title: 'Do you offer any discounts?',
        answer: (
            <Stack spacing={4}>
                <Box>
                    Yes! When you choose to pre-pay for a year of Rarchy (aka. annual billing) you'll receive a 15% discount compared to paying monthly.
                </Box>
                <Box>
                    We also offer an additional 15% discount for non-profits.
                </Box>
            </Stack>
        ),
    },
    {
        title: 'What happens to my existing projects if I upgrade?',
        answer: "Don't worry, you won't lose any of your work. All existing projects will be copied to your new organization account if you upgrade."
    },
    {
        title: 'Can I pay by invoice?',
        answer: "No, Rarchy only accepts payment via credit card at this time. Unfortunately, we cannot accept payment via invoice or any other means."
    },
    {
        title: 'What if I decide to cancel?',
        answer: "If you no longer wish to use Rarchy, you may cancel at any time, in-app, no questions asked. You'll still have access to your paid plan for the remainder of your billing cycle. "
    },
]